import type { CarouselBannerModel } from "src/features/HomepageCarouselBanners/models";

import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomToast } from "src/components/CustomToast";
import { cmsClient } from "src/services/cmsClient";
import { decamelizeKeys } from "humps";

const editBannerForm = async (data: CarouselBannerModel) => {
	const url = `/homepage/admin/carouselbanner/${data.id}/`;
	const response = await cmsClient.put(url, decamelizeKeys(data));

	return response.data;
};

const useEditBanner = () => {
	const navigate = useNavigate();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Edited Successfully" />);
		navigate("/vendor-sponsorship/homepage-carousel/banners?published=false");
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="There is an error editing the form" />
		);
	};

	const mutation = useMutation(editBannerForm, { onSuccess, onError });
	return mutation;
};

export default useEditBanner;
